import * as React from 'react';
import { PopupCallout } from './parts';
import { IPopupProps } from './popup-props';

export const Popup = React.memo((props: IPopupProps) => {
    const { onDismiss, hidden, hideCloseButton, onRenderContent, onRenderFooter, footerAlignment, titleAlignment,
        showModal, className, title, onInjectCustomContent, onRenderTitle, moveable, useFullHeight, useFullWidth } = props;

    const [isHiddenFromState, setHiddenState] = React.useState(hidden);

    const isHidden = React.useMemo(() => (hidden !== undefined ? hidden : isHiddenFromState), [hidden, isHiddenFromState]);

    const _onDismiss = React.useCallback(() => {
        if (hidden === undefined) {
            setHiddenState(true);
        }
        if (onDismiss) {
            onDismiss();
        }
    }, [hidden, onDismiss]);

    return isHidden ? null : (
        <PopupCallout hideCloseButton={hideCloseButton} className={className} titleAlignment={titleAlignment}
            onCloseClick={_onDismiss} onRenderContent={onRenderContent} moveable={moveable}
            onRenderFooter={onRenderFooter} footerAlignment={footerAlignment} showModal={showModal} title={title}
            onInjectCustomContent={onInjectCustomContent} onRenderTitle={onRenderTitle} useFullHeight={useFullHeight} useFullWidth={useFullWidth} />
    );
});

Popup.displayName = 'Popup';
